import styled from "styled-components";
import colors from "../../../../../styles/colors";

export const ContentPreviewBox = styled.div`
  padding: 1.5rem;
  background-color: ${colors.lightgrey2};
  max-width: 100%;
  box-shadow: 5px 5px 40px -14px rgba(0, 0, 0, 0.35);
  border-radius: 1rem;
`;
